import { Dispatch } from "@reduxjs/toolkit";
import apiFetch from "../token-guard/apiFetch";
import { HotelSearchRequest } from "@/types/Search";

export async function initHotelSearch(
  data: HotelSearchRequest,   dispatch: Dispatch,
) {
  const encodedBody = Buffer.from(JSON.stringify(data)).toString('base64');
  try {
  const response = await apiFetch("/api/search/init-hotel-search", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encodedBody)
    },dispatch);

  return await response;
  } catch (error) {
    console.error("Error initializing search:", error);
    return (error as Error).message;
  }
}
